import { HOME_WIDGETS_PRIORITY } from './constants';
import type { HomeWidgetType, HomeWidgetsPriority } from './types';

type SortableWidget = { type: HomeWidgetType; weight?: number };

const sortByWeight = (a: SortableWidget, b: SortableWidget) => {
  const orderA = a.weight || 0;
  const orderB = b.weight || 0;
  if (orderA < orderB) {
    return 1;
  } else if (orderA > orderB) {
    return -1;
  } else {
    return 0;
  }
};

// `home_widgets_order` contract: number = position (ascending), null = hidden, missing key or flag undefined =
// code default (so an unchanged flag keeps today's lobby).
const resolvePriority = (type: HomeWidgetType, priority?: HomeWidgetsPriority): number | null => {
  const position = priority?.[type];
  return position === undefined ? HOME_WIDGETS_PRIORITY[type] : position;
};

export const sortHomeWidgets = <T extends SortableWidget>(widgetsList: T[], priority?: HomeWidgetsPriority): T[] =>
  widgetsList
    .flatMap((widget) => {
      const position = resolvePriority(widget.type, priority);
      return position === null ? [] : [{ widget, position }];
    })
    .sort((a, b) => a.position - b.position || sortByWeight(a.widget, b.widget))
    .map(({ widget }) => widget);
